import {
  stringMaxLengthIsInvalid,
  stringIsInvalid,
} from 'store/utils/validators';
import MESSAGES from 'constants/messages';
import { Fields, OnCheckEntityName } from '../../types';

type Validate = (
  field: string,
  onCheckEntityName: OnCheckEntityName,
) => Promise<string>;

const validate: Validate = (entityName, onCheckEntityName) =>
  new Promise(resolve => {
    if (!entityName || stringIsInvalid(entityName)) {
      resolve(MESSAGES.ENTITIES.NAME.REGEX);
    }

    if (stringMaxLengthIsInvalid(entityName)) {
      resolve(MESSAGES.ENTITIES.NAME.MAX_LENGTH);
    }

    onCheckEntityName('entityName', entityName)
      .then(() => resolve())
      .catch(({ entityName }: Fields) => resolve(entityName));
  });

export default validate;
